import { LocalStorageService } from './LocalStorageService';
import { LocalStorageKeys, PreferredUniversePreference } from '../types/localStorage';

const PREFERRED_UNIVERSE_COOKIE = 'selected_universe_slug';
const PREFERRED_UNIVERSE_TTL_DAYS = 30;
const PREFERRED_UNIVERSE_TTL_MS =
    PREFERRED_UNIVERSE_TTL_DAYS * 24 * 60 * 60 * 1000;
const PREFERRED_UNIVERSE_TTL_SECONDS =
    PREFERRED_UNIVERSE_TTL_DAYS * 24 * 60 * 60;

const isExpired = (expiresAt: number) => Date.now() >= expiresAt;

export class SelectedUniverseService {
    static getPreference(): PreferredUniversePreference | null {
        const storedPreference = LocalStorageService.getItem(
            LocalStorageKeys.PREFERRED_UNIVERSE,
        );

        if (!storedPreference) {
            return null;
        }

        if (isExpired(storedPreference.expiresAt)) {
            this.clearPreference();
            return null;
        }

        return storedPreference;
    }

    static setPreference(slug: string): PreferredUniversePreference {
        const preference = {
            slug,
            expiresAt: Date.now() + PREFERRED_UNIVERSE_TTL_MS,
        };

        LocalStorageService.setItem(
            LocalStorageKeys.PREFERRED_UNIVERSE,
            preference,
        );
        this.setCookie(slug);

        return preference;
    }

    static clearPreference() {
        LocalStorageService.removeItem(LocalStorageKeys.PREFERRED_UNIVERSE);
        document.cookie = `${PREFERRED_UNIVERSE_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
    }

    static syncCookieFromStorage() {
        const preference = this.getPreference();

        if (!preference) {
            return;
        }

        this.setCookie(preference.slug);
    }

    static shouldPrompt(universesCount: number): boolean {
        if (universesCount <= 1) {
            return false;
        }

        return this.getPreference() === null;
    }

    private static setCookie(slug: string) {
        document.cookie = `${PREFERRED_UNIVERSE_COOKIE}=${encodeURIComponent(slug)}; path=/; max-age=${PREFERRED_UNIVERSE_TTL_SECONDS}; SameSite=Lax`;
    }
}
